import React from "react";
import Sidebar from "./../components/sidebar";
import Header from "./../components/Header";
import EditFaqMain from "../components/faqs/EditFaqMain";

const FaqEditScreen = ({ match }) => {
  const faqId = match.params.id;
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <EditFaqMain faqId={faqId} />
      </main>
    </>
  );
};
export default FaqEditScreen;